import {FC, useMemo} from "react";
import {ProgressLine, ProgressLineWrapper} from "../styles";

export const ProgressBarLine: FC<{value: number, onChange: (event: number) => void, maxValue?: number}> = ({value, onChange, maxValue}) => {

    const max = useMemo(() => maxValue || 100, [maxValue]);
    const percent = useMemo(() => value / max * 100, [value, max]);

    const handleChange = (event: any) => {
        onChange(Number(event.target.value));
    }


    return (
        <ProgressLineWrapper>
            <ProgressLine
                progressBarPercent={percent}
                type="range"
                min="0"
                max={max}
                value={value}
                onChange={handleChange}
            />
        </ProgressLineWrapper>
    )
}import {FC, useMemo} from "react";
import {ProgressLine, ProgressLineWrapper} from "../styles";

export const ProgressBarLine: FC<{value: number, onChange: (event: number) => void, maxValue?: number}> = ({value, onChange, maxValue}) => {

    const max = useMemo(() => maxValue || 100, [maxValue]);
    const percent = useMemo(() => value / max * 100, [value, max]);

    const handleChange = (event: any) => {
        onChange(Number(event.target.value));
    }


    return (
        <ProgressLineWrapper>
            <ProgressLine
                progressBarPercent={percent}
                type="range"
                min="0"
                max={max}
                value={value}
                onChange={handleChange}
            />
        </ProgressLineWrapper>
    )
}